<template>
  <div>
    <app-bar v-if="isAuthenticated && !isReportsView" />

    <side-bar v-if="isAuthenticated && !isReportsView" />

    <v-main class="ma-6">
      <router-view />

      <div v-if="isAuthenticated">
        <select-form-dialog :visible.sync="selectFormDialogVisible" />
        <team-form-dialog :visible.sync="teamFormDialogVisible" />
        <coach-form-dialog :visible.sync="coachFormDialogVisible" />
        <profile-form-dialog :visible.sync="profileFormDialogVisible" />
        <event-form-dialog :visible.sync="eventFormDialogVisible" />
        <location-form-dialog :visible.sync="locationFormDialogVisible" />
        <diagnostic-protocol-form-dialog :visible.sync="diagnosticProtocolFormDialogVisible" />
        <training-protocol-form-dialog :visible.sync="trainingProtocolFormDialogVisible" />
        <training-exercise-form-dialog :visible.sync="trainingExerciseFormDialogVisible" />
        <training-program-form-dialog :visible.sync="trainingProgramFormDialogVisible" />
        <diagnostic-results-dialog :visible.sync="diagnosticResultsFormDialogVisible" />
        <device-form-dialog :visible.sync="deviceFormDialogVisible" />
        <membership-plan-form-dialog :visible.sync="membershipPlanFormDialogVisible" />
        <parent-form-dialog :visible.sync="parentFormDialogVisible" />
        <injury-form-dialog :visible.sync="injuryFormDialogVisible" />
        <illness-form-dialog :visible.sync="illnessFormDialogVisible" />
        <tournament-form-dialog :visible.sync="tournamentFormDialogVisible" />
        <change-language-dialog :visible.sync="changeLanguageDialogVisible" />
        <support-dialog :visible.sync="supportDialogVisible" />
        <layouts-form-dialog :visible.sync="layoutFormDialogVisible" />
        <questionnaire-form-dialog :visible.sync="questionnaireFormDialogVisible" />
        <questionnaire-instance-form-dialog :visible.sync="questionnaireInstanceFormDialogVisible" />
      </div>
    </v-main>

    <alert />
  </div>
</template>

<script>
import { CoachFormDialog, ProfileFormDialog, EventFormDialog, SelectFormDialog, TeamFormDialog } from '@/components/dialogs'
import Alert from '@/components/helpers/Alert'
import AppBar from '@/components/AppBar'
import LocationFormDialog from '@/components/dialogs/LocationFormDialog'
import DeviceFormDialog from '@/components/dialogs/DeviceFormDialog'
import MembershipPlanFormDialog from '@/components/dialogs/MembershipPlanFormDialog'
import ParentFormDialog from '@/components/dialogs/ParentFormDialog.vue'
import TrainingProtocolFormDialog from '@/components/dialogs/TrainingProtocolFormDialog.vue'
import TrainingExerciseFormDialog from '@/components/dialogs/TrainingExerciseFormDialog.vue'
import InjuryFormDialog from '@/components/dialogs/InjuryFormDialog.vue'
import IllnessFormDialog from '@/components/dialogs/IllnessFormDialog.vue'
import TrainingProgramFormDialog from '@/components/dialogs/TrainingProgramFormDialog.vue'
import TournamentFormDialog from '@/components/dialogs/TournamentFormDialog.vue'
import ChangeLanguageDialog from '@/components/dialogs/ChangeLanguageDialog.vue'
import SideBar from '@/components/SideBar.vue'
import SupportDialog from '@/components/dialogs/SupportDialog.vue'
import DiagnosticProtocolFormDialog from '@/components/dialogs/DiagnosticProtocolFormDialog.vue'
import DiagnosticResultsDialog from '@/components/dialogs/DiagnosticResultsDialog.vue'
import LayoutsFormDialog from '@/components/dialogs/LayoutsFormDialog.vue'
import QuestionnaireFormDialog from '@/components/dialogs/QuestionnaireFormDialog.vue'
import { RouteNames } from '@/router/routes'
import QuestionnaireInstanceFormDialog from '@/components/dialogs/QuestionnaireInstanceFormDialog.vue'

export default {
  name: 'MainLayout',
  components: { IllnessFormDialog, ProfileFormDialog, QuestionnaireInstanceFormDialog, QuestionnaireFormDialog, LayoutsFormDialog, DiagnosticResultsDialog, DiagnosticProtocolFormDialog, SupportDialog, ChangeLanguageDialog, SideBar, TrainingProgramFormDialog, TournamentFormDialog, InjuryFormDialog, TrainingExerciseFormDialog, TrainingProtocolFormDialog, ParentFormDialog, MembershipPlanFormDialog, DeviceFormDialog, LocationFormDialog, EventFormDialog, CoachFormDialog, SelectFormDialog, Alert, AppBar, TeamFormDialog },
  data () {
    return {
      selectFormDialogVisible: false,
      playerFormDialogVisible: false,
      teamFormDialogVisible: false,
      coachFormDialogVisible: false,
      profileFormDialogVisible: false,
      eventFormDialogVisible: false,
      locationFormDialogVisible: false,
      diagnosticProtocolFormDialogVisible: false,
      trainingProtocolFormDialogVisible: false,
      trainingExerciseFormDialogVisible: false,
      trainingProgramFormDialogVisible: false,
      deviceFormDialogVisible: false,
      membershipPlanFormDialogVisible: false,
      parentFormDialogVisible: false,
      injuryFormDialogVisible: false,
      illnessFormDialogVisible: false,
      tournamentFormDialogVisible: false,
      changeLanguageDialogVisible: false,
      supportDialogVisible: false,
      layoutFormDialogVisible: false,
      diagnosticResultsFormDialogVisible: false,
      questionnaireFormDialogVisible: false,
      questionnaireInstanceFormDialogVisible: false
    }
  },
  computed: {
    appInitialized() {
      return this.$store.getters[this.$storeGetters.APP_INITIALIZED]
    },
    appHasErrors() {
      return this.$store.getters[this.$storeGetters.APP_HAS_ERRORS]
    },
    appLoading() {
      return this.$store.getters[this.$storeGetters.APP_LOADING]
    },
    isAuthenticated() {
      return this.$store.getters[this.$storeGetters.IS_AUTHENTICATED]
    },
    isAuthLoading() {
      return this.$store.getters[this.$storeGetters.AUTH_LOADING]
    },
    isReportsView() {
      return this.$route.name === RouteNames.REPORTS
    }
  }
}
</script>
